// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Vq8Y","clinicsSelect":"styles_clinicsSelect__2HlIr"};